import FieldInfo from "./FieldInfo";
import { FIELD_INFO } from "./fieldInfoContent";

/**
 * Field guide for Step 3. Surfaces a real (i) info popover (exact spec copy)
 * for every plan + unit-price field, so each field the editor exposes has its
 * help text one click away. Presentation-only.
 */
const PLAN_FIELDS = [
  ["Name", "plan.name"],
  ["Description", "plan.description"],
  ["Currency", "plan.currency"],
  ["Region", "plan.region"],
  ["Price type", "plan.price_type"],
  ["Unit price type", "plan.unit_price_type"],
  ["Modify orders", "plan.modify_orders"],
  ["Trial period (days)", "plan.trial_period_days"],
  ["Price validity", "plan.price_validity"],
  ["Tags", "plan.tags"],
  ["Plan highlights", "plan.plan_highlight"],
  ["Status", "plan.status"],
];

const UNIT_FIELDS = [
  ["Start / End range", "unit.start_range"],
  ["Steps", "unit.steps"],
  ["Marketplace price", "unit.marketplace_price"],
  ["Industry price", "unit.industry_price"],
  ["Vendor price", "unit.vendor_price"],
  ["Min / Max price", "unit.min_price"],
  ["HSN / SAC code", "unit.hsn_code"],
  ["Default tier", "unit.default"],
];

function Group({ title, fields }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={styles.groupTitle}>{title}</div>
      <ul style={styles.list}>
        {fields.map(([label, key]) => (
          <li key={key} style={styles.row}>
            <span style={styles.label}>{label}</span>
            <FieldInfo text={FIELD_INFO[key]} label={`About ${label}`} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function FieldGuide() {
  return (
    <div style={styles.wrap}>
      <div style={styles.head}>Field guide</div>
      <p style={styles.sub}>
        Click any (i) for what a field means and how it's used.
      </p>
      <Group title="Plan" fields={PLAN_FIELDS} />
      <Group title="Unit prices" fields={UNIT_FIELDS} />
    </div>
  );
}

const styles = {
  wrap: {
    border: "1px solid #e6e6ee",
    borderRadius: 14,
    background: "#fff",
    padding: 16,
  },
  head: { fontSize: 14, fontWeight: 800, color: "#111827" },
  sub: { fontSize: 12, color: "#8a94a6", margin: "2px 0 12px" },
  groupTitle: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.4,
    color: "#6b7280",
    marginBottom: 4,
  },
  list: { listStyle: "none", margin: 0, padding: 0 },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 0",
    borderBottom: "1px solid #f1f2f7",
  },
  label: { fontSize: 13, color: "#374151" },
};
